import { createSlice } from '@reduxjs/toolkit'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { formatDateTimeLocal, getBaseUrl } from '../../Utils'
import { TabType } from './PSFS_StatPortal'


const initialState = {
    timezone: '',
}
export interface PSFSDevices {
    _key: number
    fk_locaction: number // Foreign key to the location
    DeviceName: string
    URL: string // e.g., "Hospital", "Clinic", etc.
}

export interface ApiDTO_PSFSform {
    _Id: number // -1
    CaseId: string
    PSFSId: string // Unique identifier for the PSFS form, can be a GUID or similar
    PatientCellNumber?: string | null

    // NTTC Tab 1
    ts_Appointment?: string | null // consult date and time
    fk_TSP?: number // tablet service provider 
    fk_ContactNational?: number//Contact National Tablet team to Order
    fk_AppointmentReservedInTMP?: number //Appointment Reserved in TMP
    fk_AnnieTextMessages?: number //Veteran has a cellphone and agrees to participate in Annie text messages
    fk_DocumentOnConsultInCPRS?: number //Document on consult in CPRS

    //TMP Tab 2
    SerialNumber?: string | null //iPad serial number
    fk_RemoveReserveInTMP?: number //Remove reserve resource and schedule in TMP
    fk_VerifyAppointmentInVCM?: number //  Verify appointment dispatches in VCM
    fk_VideoDeviceConsultComments?: number // Video device consult comments added (with serial number) and completed

    //two week setup call tab 3
    ts_DeliveryDate?: string | null
    IOSVersion?: string | null //iOS version
    fk_AnnieBpReminders?: number // Annie BP reminders set up
    fk_TestCallCompleted?: number // Was a test call Completed?
    fk_StrokeRecoveryAppInstalled?: number // Was stroke recovery app installed?
    fk_Step?: number
    fk_Status?: number
    PatientCell?: string | null
    LastName?: string | null
    FirstName?: string | null
    PatientSSN?: string | null
    PatientDOB  ?: string | null
    fk_Facility?: number
    // Comments
    Comments?: DTO_PSFSCaseNote[]
    FullSSN?: string | null

    fk_CreatedBy: number
    tzCode?: string | null
    ts_RowCreated?: string | null // Timestamp when the row was created
    ts_RowUpdated?: string | null // Timestamp when the row was updated
     fk_UpdatedBy: number
     Processed:number
     PatientAge: number 
     fk_LatestComment?: number
}

export const initialFormState: ApiDTO_PSFSform = {
    _Id: -1,
    CaseId: '',
    PSFSId: '',
    fk_CreatedBy: -1,
    PatientCellNumber: '',
    ts_Appointment: null,
    fk_TSP: -1,
    fk_ContactNational: -1,
    fk_AppointmentReservedInTMP: -1,
    fk_AnnieTextMessages: -1,
    fk_DocumentOnConsultInCPRS: -1,
    SerialNumber: '',
    fk_RemoveReserveInTMP: -1,
    fk_VerifyAppointmentInVCM: -1,
    fk_VideoDeviceConsultComments: -1,
    ts_DeliveryDate: null,
    IOSVersion: '',
    fk_AnnieBpReminders: -1,
    fk_TestCallCompleted: -1,
    fk_StrokeRecoveryAppInstalled: -1,
    fk_Step: -1,
    fk_Status: -1,
    PatientCell: '',
    FullSSN: '',
    LastName: '',
    FirstName: '',
    PatientSSN: '',
    PatientDOB: '',
    fk_Facility: -1,
    Comments: [],
    tzCode: '',
    ts_RowCreated: null,
    ts_RowUpdated: null,
    fk_UpdatedBy: -1,
    Processed: 0,
    PatientAge: 0,
    fk_LatestComment: -1    
}

export interface DTO_PSFSCaseNote {
    Id: number
    CaseId: string
    ts_CreationDateTime: string | Date
    PostedByUserId: number
    PostedByUserFullName: string
    UpdatedByUserId:number
    UpdatedByUserFullName: string
    Note: string
    tzCode: string
    NoteType: string
    ExamCompleted: boolean
    isChanged: boolean
}
export interface PSFS_StatPortalProps {
    PSFSElements?: ApiDTO_PSFSUI_ElementList
    form: ApiDTO_PSFSform
    setForm: React.Dispatch<React.SetStateAction<ApiDTO_PSFSform>>
    handleSave: (close?: boolean) => void
    handleStepStatusAndSave: (stepName: string, statusKey: number, nextTab?: TabType) => Promise<void>
    errors?: { [s: string]: string }
    setErrors?: (prev: any) => void
    isSaved?: boolean
    isLoadingPSFSElements?: boolean
    caseNotes?: DTO_PSFSCaseNote[];
    setActiveTab?: React.Dispatch<React.SetStateAction<TabType>>;
    stepManuallyChanged?: boolean;
    handleStatusResetAndClose: (stepName: string, statusKey: number, nextTab?: TabType) => Promise<void>
}

export interface PSFSElement {
    _key: number
    FriendlyName: string
    ETLMatchValue:string
    StepNo?: number
    TZCode?: string
    SiteCode?: string
    VisnNo?: string
    Url?: string
}

export interface ApiDTO_PSFSUI_ElementList {
    TSP: PSFSElement[]
    YesNo: PSFSElement[]
    TCC: PSFSElement[]
    PSFSStep: PSFSElement[]
    PSFSStatus: PSFSElement[]
    Facilities: PSFSElement[]
    PSFSTime: PSFSElement[]
    PSFSUrl: PSFSElement[]
}

export const psfsSlice = createSlice({
    name: 'psfsSlice',
    initialState,
    reducers: {
        setTimezone(state, action) {
            state.timezone = action.payload
        },
    },
})

export const PSFSForm = createApi({
    reducerPath: 'PSFS',
    baseQuery: fetchBaseQuery({ baseUrl: getBaseUrl() + 'API/v3' }), //The base API path
    endpoints: (build) => ({
        GetPSFSElements: build.mutation<ApiDTO_PSFSUI_ElementList, void>({
            query: () => ({
                url: '/ActivePanel/PSFSElements',
                method: 'GET',
            }),
            transformResponse: (response: any) => {
                return response.data
            },
        }),
        GetPSFSCase: build.mutation<{ FormData: Array<{ key: string; Value: Object }> }, { caseId: string; FormGuid: string }>({//FP-14022 add appguid parameter
            query: ({ caseId, FormGuid }) => ({
                url: `/ActivePanel/GetCaseDetails?caseId=${caseId}&FormGuid=${FormGuid}`,
                method: 'GET',
            }),
            transformResponse: (response: any) => {
                return response.data
            },
        }),
        SavePSFSCase: build.mutation<any, { FormData: Array<{ key: string; Value: Object }>, FormGuid: string }>({
            query: (body) => ({
                url: '/ActivePanel/SaveNTSPCase',
                method: 'POST',
                body: body, // body is { FormData: List<KeyValue><key, Value>> }
            }),
        }),
        GetComments: build.mutation<DTO_PSFSCaseNote[], string>({
            query: (caseId) => ({
                url: `/ActivePanel/GetCaseComments?caseId=${caseId}&noteType=PSFS`,
                method: 'GET',
            }),
            transformResponse: (response: any) => {
                return response.data
            },
        }),
        SaveComments: build.mutation<DTO_PSFSCaseNote, Partial<DTO_PSFSCaseNote>>({
            query: (body) => ({
                url: '/ActivePanel/SaveComments',
                method: 'POST',
                body: body,
            }),
            transformResponse: (response: any) => {
                return response.data
            },
        }),
    }),
})

export const {
    useGetPSFSElementsMutation,
    useGetPSFSCaseMutation,
    useSavePSFSCaseMutation,
    useSaveCommentsMutation,
    useGetCommentsMutation
} = PSFSForm


export default psfsSlice.reducer